import React from "react"
import QCPanelContainer from "../components/QCPanelContainer"
import ProductTierOption from "../components/ProductTierOption";
import * as Stld from "./ProductMatrix.styles";
import { ROUTES } from "../constants/routes";
import { ADVERTISE_TIER_CONTENT, ADVERTISE_PRO_TIER_CONTENT, ENTERPRISE_TIER_CONTENT, TRADER_TIER_CONTENT } from "../constants/signup";

export const ProductMatrix = () => {

    return (
        <QCPanelContainer showMarketingMessage={false}>
            <Stld.Content>
                <Stld.QuantcastLogo />
                <Stld.CardLarge>
                    <div data-cy="header" style={{textAlign: "center"}}>
                        <Stld.H3>Choose your tier</Stld.H3>
                    </div>
                    <Stld.ProductContent>
                        <ProductTierOption {...ADVERTISE_TIER_CONTENT} />
                        <ProductTierOption {...ADVERTISE_PRO_TIER_CONTENT} />
                        <ProductTierOption {...ENTERPRISE_TIER_CONTENT} />
                        <ProductTierOption {...TRADER_TIER_CONTENT} />
                    </Stld.ProductContent>
                    <div style={{textAlign: "center", paddingTop: "5px", fontSize: "14px"}}>
                        Already registered? <a href="/selfserve/login">Log In</a>
                    </div>
                    <div style={{textAlign: "center", paddingTop: "5px", fontSize: "14px"}}>
                        Quantcast sales team? <a href={ROUTES.SELFSERVE_SIGNUP + "?orgtype=sales_prospecting&product_tier=max"}>Create a Sales Account</a>
                    </div>
                </Stld.CardLarge>
            </Stld.Content>
        </QCPanelContainer>
    )
}